import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';

export interface ShareScreenStateChangeResp {
  shareMemberUid: string;
  shareMemberDeviceId: string;
  state: number;
}

export default function useAppsStateChange() {
  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });

  const change = async () => {
    meeting?.getAppsState();
  };

  return change;
}
